export const APP_STORE_URL = "https://apps.apple.com/kz/app/heros-journey/id1542925392";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=kz.fitnesslabs.hero";
